import React from "react";
import {ReactSession} from "react-client-session";
import $ from "jquery";
import {Helpers} from "../config/Helpers";
import {MDBDataTableV5} from "mdbreact";

class Orders extends React.Component {

    constructor(props) {
        super(props);
        ReactSession.setStoreType("localStorage");
        this.state = {
            sessUserCode: (ReactSession.get("sess_usercode")) ? ReactSession.get("sess_usercode") : '',
            sessEmail: (ReactSession.get("sess_email")) ? ReactSession.get("sess_email") : '',
            orderData: []
        };
    }

    componentDidMount() {
        this.getOrders();
    }

    getOrders = () => {
        $(".loader-wrapper").css("display", "");
        Helpers.getVendorOrder('', this.state.sessUserCode, 'all').then(res => {
            $(".loader-wrapper").css("display", "none");
            this.setState({ orderData: (res) ? res : [] });
        })
    };

    render() {
        return (
            <>
                <section className="content-main">
                    <div className="content-header">
                        <div>
                            <h2 className="content-title card-title">Order List</h2>
                            <p>Find your order here</p>
                        </div>
                    </div>
                    <div className="card mb-4">
                        <div className="card-body">
                            <MDBDataTableV5
                                hover
                                fullPagination
                                entriesOptions={[10, 25, 50, 100]}
                                entries={10}
                                data={
                                    {
                                        columns: [
                                            {
                                                label: 'ID Order',
                                                field: 'kode_order',
                                            },
                                            {
                                                label: 'Date',
                                                field: 'date_created',
                                            },
                                            {
                                                label: 'Total Items',
                                                field: 'total_items_supplier',
                                            },
                                            {
                                                label: 'Total Orders',
                                                field: 'total_order_supplier_format'
                                            },
                                            {
                                                label: 'Status',
                                                field: 'status_view',
                                            }
                                        ],
                                        rows: this.state.orderData.map((row) => {
                                            return {
                                                ...row,
                                                status_view: (
                                                    <span className={'badge rounded-pill alert-success'}>{row.status_upper}</span>
                                                )
                                            };
                                        }),
                                    }
                                } />
                        </div>
                    </div>
                </section>
            </>
        );
    }
}

export default Orders;
